/* ============================================================================
   lens-category.js — <lens-category-widget>, die Objektiv-Leiste
   ==========================================================================  */

/* Die `id`s der aufgeklappten Leisten. Die Leiste in der Galerie wird bei jedem
   Variantenwechsel mit der Region vom Server ersetzt (assets/product.js).
   Das neue Element traegt dieselbe `id` und klappt sich beim Einhaengen
   wieder auf — vor dem ersten Bild, also ohne Uebergang. */
const OFFEN = new Set();

const LAST_CATEGORY = new Map();

class LensCategoryWidget extends HTMLElement {
  static get observedAttributes() {
    return ["data-variant-title"];
  }

  connectedCallback() {
    this.hoerer?.abort();
    this.hoerer = new AbortController();
    this.addEventListener("click", (e) => this.onClick(e), {
      signal: this.hoerer.signal,
    });
    /* Nur auf der Leiste selbst: Enter auf „Mehr erfahren“
       darin oeffnet das Popup und blubbert hier vorbei. */
    this.addEventListener(
      "keydown",
      (e) => {
        if (e.target !== this || (e.key !== "Enter" && e.key !== " ")) return;
        e.preventDefault();
        this.umschalten();
      },
      { signal: this.hoerer.signal },
    );
    if (this.id && OFFEN.has(this.id))
      this.setAttribute("aria-expanded", "true");
    const previous = this.id && LAST_CATEGORY.get(this.id);
    if (previous) {
      this.setAttribute("data-curr-cat", previous);
      this.updateCurrLabel(previous);
      this.querySelectorAll(".lens-category__category-icon").forEach(
        (icon) => getComputedStyle(icon).opacity,
      );
    }
    this.updateSelectedCat();
  }

  disconnectedCallback() {
    this.hoerer?.abort();
    this.hoerer = null;
  }

  attributeChangedCallback() {
    if (this.hoerer) this.updateSelectedCat();
  }

  onClick(e) {
    /* „Learn more“ liegt IN der Leiste. Sein Klick kommt hier vorbei, bevor
       er die Delegation von assets/popup.js am document erreicht
       (Bubble-Phase, bewusst ohne stopPropagation) — und klappte die offene
       Leiste hinter der Blende zu. */
    if (e.target.closest("[data-popup]")) return;
    this.umschalten();
  }

  umschalten() {
    const auf = this.getAttribute("aria-expanded") !== "true";
    this.setAttribute("aria-expanded", auf ? "true" : "false");
    if (!this.id) return;
    if (auf) OFFEN.add(this.id);
    else OFFEN.delete(this.id);
  }

  /* Dieselbe Normalisierung wie `cat_name` in snippets/lens-category.liquid. */
  normalizeAndSplit(title = "") {
    return String(title)
      .toLowerCase()
      .replace(/ /g, "")
      .replace(/-cat/g, "__cat")
      .replace(/[\/()]/g, "")
      .split("__");
  }

  updateSelectedCat() {
    const parts = this.normalizeAndSplit(
      this.getAttribute("data-variant-title") || "",
    );
    const catExist = Boolean(parts[1] && parts[1].includes("cat."));

    if (!catExist) {
      this.setAttribute("data-curr-cat", "");
      if (this.id) LAST_CATEGORY.delete(this.id);
      return;
    }

    const currCat = parts[1].replace("cat.", "").charAt(0);

    this.setAttribute("data-curr-cat", currCat);
    if (this.id) LAST_CATEGORY.set(this.id, currCat);
    this.updateCurrLabel(currCat);
  }

  updateCurrLabel(currCat) {
    const label = this.querySelector("[data-curr-label]");
    const title = this.querySelector(
      '.lens-category__category[data-cat="' +
        currCat +
        '"] .lens-category__category-title',
    );

    if (!label || !title) {
      return;
    }

    label.textContent = title.textContent.trim();
  }
}

if (!customElements.get("lens-category-widget")) {
  customElements.define("lens-category-widget", LensCategoryWidget);
}

/* NUR ALS MODUL LADEN: <script src="…" type="module">, nie mit `defer`. */
